module.exports = __webpack_public_path__ + "pc/img/work_list3.b44b4986.jpg";